import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import RightModalLayout from '../../../layouts/Modal/RightModalLayout';
import ButtonMC from '../../../components/ButtonMC';
import { closeSidebar } from '../../Orders/services/orderSidebarService';
import { listTemplates } from '../services/templatesStorage';

const SelectQuoteTemplateModal = ({ onSelect }) => {
  const { t } = useTranslation('Quotes');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug } = useParams();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleClose = () => {
    closeSidebar(dispatch, 'SelectQuoteTemplateModal');
  };

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    listTemplates(slug)
      .then((next) => {
        if (!cancelled) setTemplates(next);
      })
      .catch((error) => {
        console.error(error);
        if (!cancelled && window.showtoast) window.showtoast(t('list.loadError'));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [slug, t]);

  const handleSelect = (template) => {
    onSelect?.(template);
    handleClose();
  };

  return (
    <RightModalLayout
      closeAction={handleClose}
      title={t('quote.selectTemplate')}
      showBackButton
    >
      {loading && (
        <p className="tw-text-sm tw-text-gray-500">{t('list.loading')}</p>
      )}

      {!loading && templates.length === 0 && (
        <div className="tw-flex tw-flex-col tw-items-start tw-gap-3">
          <p className="tw-text-sm tw-text-gray-600">{t('quote.noTemplates')}</p>
          <ButtonMC
            variant="PRIMARY"
            size="small"
            text={t('quote.goToTemplates')}
            onClick={() => {
              handleClose();
              navigate(`/retailers/${slug}/quotes/templates`);
            }}
          />
        </div>
      )}

      {!loading && templates.length > 0 && (
        <div className="tw-flex tw-flex-col tw-gap-2">
          {templates.map((template) => (
            <button
              key={template.id}
              type="button"
              className="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-3 tw-py-2 tw-text-left hover:tw-border-blue-300 hover:tw-bg-gray-50"
              onClick={() => handleSelect(template)}
            >
              <p className="tw-font-medium tw-text-sm tw-text-gray-900">{template.name}</p>
              {template.isDefault && (
                <span className="tw-mt-1 tw-inline-block tw-rounded-full tw-bg-green-100 tw-px-2 tw-py-0.5 tw-text-xs tw-text-green-700">
                  {t('list.defaultBadge')}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </RightModalLayout>
  );
};

export default SelectQuoteTemplateModal;
